import axios from "axios";
import Vue from "vue";
import authHeader from "@/services/auth-header";
import config from "@/data/config";
import model from "@/data/model";

const API_URL = config.baseURL;
const myModel = model.kk;

export const keluargaKatolik = {
   namespaced: true,
   state: {
      data: [],
      item: { ...myModel },
      anggota: [],
      totalRecords: 0,
   },
   getters: {
      // countAll: (state) => {return state.data.length},
      countAll(state) {
         return state.data.length;
      },
      getById: (state) => (id) => {
         return state.data.find((data) => data.id === id);
      },
   },
   actions: {
      async getAll({ commit, rootState }) {
         rootState.isLoading = true;
         await axios
            .get(`${API_URL}keluarga_katolik`, {
               headers: authHeader(),
            })

            .then(
               (response) => {
                  commit("SET_DATA", response.data);
                  rootState.isLoading = false;
               },
               () => {
                  rootState.isLoading = false;
               }
            );
      },
      async getAllRemote({ commit, rootState }, data) {
         rootState.isLoading = true;
         return await axios
            .post(`${API_URL}keluarga_katolik/remote`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  commit("SET_DATA", response.data);
                  rootState.isLoading = false;
                  return response.data;
               },
               () => {
                  rootState.isLoading = false;
               }
            );
      },
      async getItem({ rootState }, id) {
         rootState.isLoading = true;
         return await axios
            .get(`${API_URL}keluarga_katolik/${id}`, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      async insert({ commit, rootState }, data) {
         rootState.isLoading = true;
         return await axios
            .post(`${API_URL}keluarga_katolik`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  commit("PUSH_ITEM", response.data);
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      async update({ commit, rootState }, data) {
         rootState.isLoading = true;
         return await axios
            .put(
               `${API_URL}keluarga_katolik/${data.keluarga_katolik.uid}`,
               data,
               {
                  headers: authHeader(),
               }
            )
            .then(
               (response) => {
                  commit("CHANGE_ITEM", response.data);
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      async delete({ rootState }, id) {
         rootState.isLoading = true;
         return await axios
            .delete(`${API_URL}keluarga_katolik/${id}`, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  // commit("REMOVE_ITEM", id);
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      setItem({ commit }, item) {
         commit("SET_ITEM", item);
      },
      setAnggota({ commit }, item) {
         commit("SET_ANGGOTA", item);
      },
      addAnggota({ commit }, item) {
         commit("PUSH_ANGGOTA", item);
      },
      deleteAnggota({ commit }, item) {
         commit("REMOVE_ANGGOTA", item);
      },
      setKepala({ commit }, item) {
         commit("SET_KEPALA", item);
      },
      resetItem({ commit }) {
         const item = { ...myModel };
         commit("SET_ITEM", item);
         commit("SET_ANGGOTA", []);
      },
   },
   mutations: {
      SET_DATA(state, data) {
         state.data = data.rows;
         state.totalRecords = data.totalRecords;
      },
      SET_ITEM(state, item) {
         state.item = item;
      },
      PUSH_ITEM(state, item) {
         state.data.push(item);
      },
      CHANGE_ITEM(state, payload) {
         console.log(payload);
         const index = state.data.findIndex((item) => item.id === payload.id);
         if (index !== -1) {
            Vue.set(state.data, index, payload);
         }
      },
      REMOVE_ITEM(state, id) {
         var i = state.data.findIndex((data) => data.id == id);
         state.data.splice(i, 1);
      },

      // ANGGOTA
      SET_ANGGOTA(state, item) {
         state.anggota = item;
      },
      PUSH_ANGGOTA(state, item) {
         state.anggota.push(item);
      },
      EDIT_ANGGOTA(state, payload) {
         const index = state.anggota.findIndex(
            (item) => item.uid === payload.uid
         );
         if (index !== -1) {
            Vue.set(state.anggota, index, payload);
         }
      },
      SET_KEPALA(state, umat_uid) {
         state.anggota.map((item, index) => {
            if (item.is_kepala === 1 || item.is_kepala === "1") {
               item.is_kepala = 0;
               Vue.set(state.anggota, index, item);
            }
         });

         state.anggota.forEach((item, index) => {
            let _item = item;

            _item.is_kepala = 0;
            Object.assign(item, _item);
            if (item.umat_uid == umat_uid) {
               _item.is_kepala = 1;
               Object.assign(item, _item);
            }

            console.log(index);
         });

         const isKepala = state.anggota.find((item) => item.is_kepala == 1);
         Vue.$toast.info(isKepala.nama + " Menjadi Kepala Keluarga");
      },
      REMOVE_ANGGOTA(state, uid) {
         var i = state.anggota.findIndex((item) => item.umat_uid == uid);

         state.anggota.splice(i, 1);
      },
   },
};
